<template>
  <div class="card">
    <div class="card-body">
      <b-form @submit.prevent>
        <b-row>
          <b-col md="6">
            <b-form-group label="Название старта">
              <b-form-input
                v-model="start.name"
                placeholder="Название старта"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Краткое название">
              <b-form-input
                v-model="start.short_name"
                placeholder="Краткое название"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Серийный номер">
              <b-form-input
                v-model="start.serial_number"
                placeholder="Серийный номер"
              />
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            class="switches"
          >
            <div class="switch">
              <b-card-text class="mb-0">Выводить на главную?</b-card-text>
              <b-form-checkbox
                v-model="start.on_main_page"
                checked="true"
                class="custom-control-primary"
                name="check-view"
                switch
              />
            </div>

            <div class="switch">
              <b-card-text class="mb-0"
                >Регистрация на нашем сайте?</b-card-text
              >
              <b-form-checkbox
                v-model="start.reg_on_site"
                checked="true"
                class="custom-control-primary"
                name="check-reg"
                switch
              />
            </div>

            <div class="switch">
              <b-card-text class="mb-0">Скрыть от пользователей?</b-card-text>
              <b-form-checkbox
                v-model="start.is_preview_hidden"
                class="custom-control-primary"
                name="check-preview-hidden"
                switch
              />
            </div>

            <div class="switch">
              <b-card-text class="mb-0">Отключить оплату?</b-card-text>
              <b-form-checkbox
                v-model="start.payment_disabled"
                checked="true"
                class="custom-control-primary"
                name="check-view"
                switch
              />
            </div>

            <div class="switch">
              <b-form-group label="Отключить проверку дублей?">
                <b-form-checkbox
                  v-model="start.is_multi_registration"
                  checked="false"
                  class="custom-control-primary"
                  name="check-view"
                  switch
                />
              </b-form-group>
            </div>

            <div
              v-if="start.payment_disabled"
              class="inline-block"
            >
              <b-form-group label="Способ оплаты">
                <b-form-input
                  v-model="start.payment_type"
                  placeholder="Способ оплаты"
                />
              </b-form-group>
            </div>
          </b-col>

          <b-col md="6">
            <b-form-group label="Координаты места проведения">
              <b-form-input
                v-model="start.coordinates"
                placeholder="Координаты места проведения"
              />
            </b-form-group>
          </b-col>

          <b-col
            v-if="!start.reg_on_site"
            md="6"
          >
            <b-form-group label="Ссылка на сайт регистрации">
              <b-form-input
                v-model="start.reg_link"
                placeholder="Ссылка"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="URL">
              <b-form-input
                v-model="start.slug"
                placeholder="URL"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Город проведения">
              <v-select
                v-model="start.city_id"
                taggable
                push-tags
                :options="cities"
                label="name"
                :reduce="option => option.id"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BRow,
  BCol,
  BCardText,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'GeneralInfoSection',

  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BRow,
    BCol,
    BCardText,
    vSelect,
  },

  props: {
    start: {},
    cities: {},
  },

  watch: {
    'start.reg_on_site'(value) {
      if (value) {
        this.start.reg_link = null
      }
    },
  },
}
</script>

<style scoped lang="scss">
.switches {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: 767px) {
    flex-direction: column;
  }
}

.switch {
  font-size: 12px;

  &:first-child {
    @media (max-width: 767px) {
      margin-top: 16px;
    }
  }
}
</style>

<!-- Если хочешь локально переопределить цвет индикации v-select -->
<style lang="scss">
.vs__open-indicator {
  fill: #7367f0;
}
</style>
